import { Injectable, inject } from '@angular/core'
import { UserGroupPermissionId } from '@ftr/contracts/api/user-group'
import { StaticMenuItem } from '@ftr/menus'
import { UserState } from '@ftr/ui-user'
import { Store } from '@ngxs/store'
import { Observable, combineLatest, map } from 'rxjs'
import { GlobalNavItems } from './global-nav-items'
import { NavItemsProvider } from './nav-item'

@Injectable({
  providedIn: 'root',
})
export class AccountMenuItemsProvider implements NavItemsProvider {
  private readonly globalNavItems = inject(GlobalNavItems)
  private readonly store = inject(Store)

  provide(): Observable<StaticMenuItem[]> {
    return combineLatest([
      this.store
        .select(UserState.hasAnyPermissionInCourtSystem)
        .pipe(
          map(fn =>
            fn([
              UserGroupPermissionId.ProcessAudioOrders,
              UserGroupPermissionId.ProcessRealTimeOrders,
              UserGroupPermissionId.ProcessTranscriptOrders,
              UserGroupPermissionId.PlaybackRecordings,
              UserGroupPermissionId.TranscribeRecordings,
            ]),
          ),
        ),
      this.store.select(UserState.isGlobalAdmin),
    ]).pipe(
      map(([hasProcessingPermissions, isGlobalAdmin]) => {
        const items = [this.globalNavItems.accountDetails(), this.globalNavItems.myAuditLog()]

        if (isGlobalAdmin || hasProcessingPermissions) {
          items.push(this.globalNavItems.sharedRecordings())
        }

        items.push(this.globalNavItems.getDesktopApp(), this.globalNavItems.logout())

        return items
      }),
    )
  }
}
